import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const AboutPageViewModal = ({ isOpen, onClose, content, loading }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.85, y: 50 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.85, y: 50 }}
          transition={{ type: "spring", stiffness: 300 }}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "800px",
            borderRadius: "16px",
            padding: "28px",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <h3
            style={{
              margin: "0 0 24px",
              fontSize: "22px",
              fontWeight: "700",
              color: "#1f2937",
            }}
          >
            "Biz haqimizda" ma'lumotlari
          </h3>

          {loading ? (
            <div style={{ textAlign: "center", padding: "100px 0" }}>
              <p>Yuklanmoqda...</p>
            </div>
          ) : content ? (
            <div className="about-detail-view">
              {content.imageUrl && (
                <div style={{ marginBottom: "28px", textAlign: "center" }}>
                  <img
                    src={content.imageUrl}
                    alt={content.title || "Rasm"}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "400px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/600x300?text=Rasm+yuklanmadi";
                    }}
                  />
                </div>
              )}

              <div className="detail-row">
                <span className="label">Sarlavha:</span>
                <span style={{ fontWeight: "600" }}>
                  {content.title || "—"}
                </span>
              </div>

              <div className="detail-row">
                <span className="label">Qisqa tavsif:</span>
                <span>{content.shortDescription || "—"}</span>
              </div>

              <div className="detail-row" style={{ alignItems: "flex-start" }}>
                <span className="label">To‘liq tavsif:</span>
                <div
                  style={{
                    whiteSpace: "pre-wrap",
                    lineHeight: "1.6",
                    color: "#374151",
                    marginTop: "4px",
                  }}
                >
                  {content.fullDescription || "—"}
                </div>
              </div>

              <div className="detail-row">
                <span className="label">Status:</span>
                <span
                  style={{
                    padding: "6px 14px",
                    borderRadius: "20px",
                    fontSize: "14px",
                    fontWeight: "600",
                    background:
                      content.displayStatus === "Confirmed"
                        ? "#ecfdf5"
                        : content.displayStatus === "Pending"
                        ? "#fffbeb"
                        : content.displayStatus === "Modified"
                        ? "#fef3f0"
                        : content.displayStatus === "Cancelled"
                        ? "#fef2f2"
                        : "#f3f4f6",
                    color:
                      content.displayStatus === "Confirmed"
                        ? "#10b981"
                        : content.displayStatus === "Pending"
                        ? "#d97706"
                        : content.displayStatus === "Modified"
                        ? "#c2410c"
                        : content.displayStatus === "Cancelled"
                        ? "#dc2626"
                        : "#6b7280",
                  }}
                >
                  {content.displayStatus === "Confirmed"
                    ? "Tasdiqlangan"
                    : content.displayStatus === "Pending"
                    ? "Kutilmoqda"
                    : content.displayStatus === "Modified"
                    ? "O‘zgartirilgan"
                    : content.displayStatus === "Cancelled"
                    ? "Bekor qilingan"
                    : "—"}
                </span>
              </div>

              <div className="detail-row">
                <span className="label">ID:</span>
                <span style={{ fontFamily: "monospace", fontSize: "13px" }}>
                  {content.id}
                </span>
              </div>
            </div>
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#e74c3c",
                padding: "80px 0",
              }}
            >
              Ma'lumot topilmadi
            </p>
          )}

          <div style={{ marginTop: "32px", textAlign: "right" }}>
            <button className="btn-cancel" onClick={onClose}>
              Yopish
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AboutPageViewModal;
